/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {SearchSettings} from '../models/SearchSettings';
import type {SearchSettingsRequest} from '../models/SearchSettingsRequest';

export interface CreateSearchSettings$Request {
    searchSettingsRequest: SearchSettingsRequest;
}

export interface CreateSearchSettings$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const createSearchSettingsRequest = createAction<PayloadData<void, CreateSearchSettings$Request>>('CONFERENCE_SEARCH_SETTINGS__CREATE_SEARCH_SETTINGS__REQUEST');
export const createSearchSettingsSuccess = createAction<PayloadData<void, CreateSearchSettings$Request>>('CONFERENCE_SEARCH_SETTINGS__CREATE_SEARCH_SETTINGS__SUCCESS');
export const createSearchSettingsFailure = createAction<PayloadData<Error, CreateSearchSettings$Request, true>>('CONFERENCE_SEARCH_SETTINGS__CREATE_SEARCH_SETTINGS__FAILURE');

export const createSearchSettingsActions = [
    createSearchSettingsRequest,
    createSearchSettingsSuccess,
    createSearchSettingsFailure
] as const;

/**
 * @param {SearchSettingsRequest} meta.searchSettingsRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const createSearchSettings = (meta: CreateSearchSettings$Request, config?: CreateSearchSettings$Config) => {
    return {
        CALL_API: {
            types: createSearchSettingsActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/conferences/search-settings`,
            TRANSPORT_REQUEST_BODY: meta.searchSettingsRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetSearchSettings$Request {
    conferenceId: number;
}

export interface GetSearchSettings$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getSearchSettingsRequest = createAction<PayloadData<void, GetSearchSettings$Request>>('CONFERENCE_SEARCH_SETTINGS__GET_SEARCH_SETTINGS__REQUEST');
export const getSearchSettingsSuccess = createAction<PayloadData<Array<SearchSettings>, GetSearchSettings$Request>>('CONFERENCE_SEARCH_SETTINGS__GET_SEARCH_SETTINGS__SUCCESS');
export const getSearchSettingsFailure = createAction<PayloadData<Error, GetSearchSettings$Request, true>>('CONFERENCE_SEARCH_SETTINGS__GET_SEARCH_SETTINGS__FAILURE');

export const getSearchSettingsActions = [
    getSearchSettingsRequest,
    getSearchSettingsSuccess,
    getSearchSettingsFailure
] as const;

/**
 * @param {number} meta.conferenceId The conference id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getSearchSettings = (meta: GetSearchSettings$Request, config?: GetSearchSettings$Config) => {
    return {
        CALL_API: {
            types: getSearchSettingsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/conferences/${meta.conferenceId}/search-settings`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetSectionSearchSettings$Request {
    conferenceId: number;
    sectionId: number;
}

export interface GetSectionSearchSettings$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getSectionSearchSettingsRequest = createAction<PayloadData<void, GetSectionSearchSettings$Request>>('CONFERENCE_SEARCH_SETTINGS__GET_SECTION_SEARCH_SETTINGS__REQUEST');
export const getSectionSearchSettingsSuccess = createAction<PayloadData<Array<SearchSettings>, GetSectionSearchSettings$Request>>('CONFERENCE_SEARCH_SETTINGS__GET_SECTION_SEARCH_SETTINGS__SUCCESS');
export const getSectionSearchSettingsFailure = createAction<PayloadData<Error, GetSectionSearchSettings$Request, true>>('CONFERENCE_SEARCH_SETTINGS__GET_SECTION_SEARCH_SETTINGS__FAILURE');

export const getSectionSearchSettingsActions = [
    getSectionSearchSettingsRequest,
    getSectionSearchSettingsSuccess,
    getSectionSearchSettingsFailure
] as const;

/**
 * @param {number} meta.conferenceId The conference id
 * @param {number} meta.sectionId The section id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getSectionSearchSettings = (meta: GetSectionSearchSettings$Request, config?: GetSectionSearchSettings$Config) => {
    return {
        CALL_API: {
            types: getSectionSearchSettingsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/conferences/${meta.conferenceId}/sections/${meta.sectionId}/search-settings`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface RemoveSearchSettings$Request {
    settingsId: number;
}

export interface RemoveSearchSettings$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const removeSearchSettingsRequest = createAction<PayloadData<void, RemoveSearchSettings$Request>>('CONFERENCE_SEARCH_SETTINGS__REMOVE_SEARCH_SETTINGS__REQUEST');
export const removeSearchSettingsSuccess = createAction<PayloadData<void, RemoveSearchSettings$Request>>('CONFERENCE_SEARCH_SETTINGS__REMOVE_SEARCH_SETTINGS__SUCCESS');
export const removeSearchSettingsFailure = createAction<PayloadData<Error, RemoveSearchSettings$Request, true>>('CONFERENCE_SEARCH_SETTINGS__REMOVE_SEARCH_SETTINGS__FAILURE');

export const removeSearchSettingsActions = [
    removeSearchSettingsRequest,
    removeSearchSettingsSuccess,
    removeSearchSettingsFailure
] as const;

/**
 * @param {number} meta.settingsId The search settings id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const removeSearchSettings = (meta: RemoveSearchSettings$Request, config?: RemoveSearchSettings$Config) => {
    return {
        CALL_API: {
            types: removeSearchSettingsActions,
            method: ApiMethods.DELETE,
            endpoint: `/web-api/conferences/search-settings/${meta.settingsId}`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface UpdateSearchSettings$Request {
    settingsId: number;
    searchSettingsRequest: SearchSettingsRequest;
}

export interface UpdateSearchSettings$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const updateSearchSettingsRequest = createAction<PayloadData<void, UpdateSearchSettings$Request>>('CONFERENCE_SEARCH_SETTINGS__UPDATE_SEARCH_SETTINGS__REQUEST');
export const updateSearchSettingsSuccess = createAction<PayloadData<void, UpdateSearchSettings$Request>>('CONFERENCE_SEARCH_SETTINGS__UPDATE_SEARCH_SETTINGS__SUCCESS');
export const updateSearchSettingsFailure = createAction<PayloadData<Error, UpdateSearchSettings$Request, true>>('CONFERENCE_SEARCH_SETTINGS__UPDATE_SEARCH_SETTINGS__FAILURE');

export const updateSearchSettingsActions = [
    updateSearchSettingsRequest,
    updateSearchSettingsSuccess,
    updateSearchSettingsFailure
] as const;

/**
 * @param {number} meta.settingsId The search settings id
 * @param {SearchSettingsRequest} meta.searchSettingsRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const updateSearchSettings = (meta: UpdateSearchSettings$Request, config?: UpdateSearchSettings$Config) => {
    return {
        CALL_API: {
            types: updateSearchSettingsActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/conferences/search-settings/${meta.settingsId}`,
            TRANSPORT_REQUEST_BODY: meta.searchSettingsRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

